<template>
  <v-stepper
    id="workspace-batch-stepper"
    v-model="e6"
  >
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-stepper-header>
      <v-stepper-step
        :complete="e6 > 1"
        step="1"
        dark
        color="color_green"
      >
        Workspaces & Layers
      </v-stepper-step>
      <v-divider />
      <v-stepper-step
        step="2"
        dark
        color="color_green"
      >
        Geographical domain
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card
          flat
          class="mb-4"
        >
          <v-card-title>Workspaces</v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="geoserver_data.selectedWorkspaces"
              label="Workspaces"
              :items="geoserver_data.geoserverWorkspaces"
              color="color_green"
              outlined
              multiple
              chips
              deletable-chips
              small-chips
              hint="Seleziona uno o più workspace: sotto vedrai solo i layer comuni a tutti"
              persistent-hint
              @change="onWorkspacesChange"
            />
          </v-card-text>
          <div v-if="geoserver_data.selectedWorkspaces.length > 0">
            <layers-selector />
          </div>
        </v-card>
        <v-row>
          <v-col cols="2">
            <v-btn
              dark
              color="warning"
              @click="closeBatch"
            >
              Close
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col
            cols="3"
            class="text-right"
          >
            <v-btn
              dark
              color="color_green"
              :disabled="checkFormStep1()"
              @click="goToDomain"
            >
              Continue
            </v-btn>
          </v-col>
        </v-row>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card
          flat
          class="mb-12"
        >
          <v-card outlined>
            <v-toolbar
              flat
              dark
              color="color_green"
            >
              <v-spacer />
              <v-toolbar-title> Domains </v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-virtual-scroll
              :items="geoserver_data.batchDomains"
              bench="5"
              max-height="300"
              item-height="64"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.domain_name">
                  <v-list-item-content>
                    <v-list-item-title>
                      Domain: {{ item.domain_id }} - {{ item.domain_name }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon>
                      <delete
                        :id="item.domain_name"
                        @deleted="removeBatchDomain(item.domain_id)"
                      />
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
              </template>
            </v-virtual-scroll>
          </v-card>
          <v-card-actions>
            <v-row>
              <v-col cols="10">
                <v-autocomplete
                  v-model="domainToAdd"
                  label="Domain"
                  :items="geoserver_data.domainsWS"
                  item-text="domain_name"
                  :search-input.sync="searchDomainAutocomplete"
                  :filter="customFilter"
                  color="color_green"
                  outlined
                  hint="Click the icon to add"
                  return-object
                >
                  <template v-slot:selection="{ item }">
                    <span
                      class="d-inline-block text-truncate"
                      style="max-width: 30em"
                    >
                      {{ item.domain_id }} - {{ item.domain_name }}
                    </span>
                  </template>
                  <template
                    v-slot:[`item`]="{ item }"
                    class="d-grid"
                  >
                    <span
                      class="d-inline-block text-truncate"
                      style="max-width: 30em"
                    >
                      {{ item.domain_id }} - {{ item.domain_name }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2">
                <v-btn
                  height="55"
                  color="primary"
                  @click="addNewDomain"
                >
                  <v-icon large>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-row>
          <v-col cols="2">
            <v-btn
              dark
              color="warning"
              @click="closeBatch"
            >
              Close
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col
            cols="5"
            class="text-right"
          >
            <v-btn
              text
              @click="e6 = 1"
            >
              Cancel
            </v-btn>
            <v-btn
              dark
              color="primary"
              @click="confirmButtonEvent"
            >
              Confirm
            </v-btn>
          </v-col>
        </v-row>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    LayersSelector: () => import('@/components/policy/LayersSelector'),
    delete: () => import('@/components/utils/Delete')
  },
  data() {
    return {
      e6: 1,
      overlay: false,
      searchDomainAutocomplete: '',
      domainToAdd: null
    };
  },
  computed: {
    ...mapState(['geoserver_data'])
  },
  created() {
    this.geoserver_data.geoserverLayers = [];
  },
  methods: {
    ...mapActions([
      'storeCommonWSLayers',
      'storeBatchDomain',
      'removeBatchDomain',
      'resetBatchState',
      'storeWorkspacesBatch',
      'storeDomainsWS'
    ]),
    onWorkspacesChange() {
      this.storeCommonWSLayers(this.geoserver_data.selectedWorkspaces);
    },
    checkFormStep1() {
      return (
        this.geoserver_data.selectedWorkspaces.length <= 0 ||
        this.geoserver_data.chosenLayers.length <= 0
      );
    },
    async goToDomain() {
      this.e6 = 2;
      await this.storeDomainsWS();
    },
    async addNewDomain() {
      if (!this.domainToAdd) {
        return;
      }

      await this.storeBatchDomain({
        id: this.domainToAdd.domain_id,
        name: this.domainToAdd.domain_name
      });
      this.domainToAdd = null;
    },
    async confirmButtonEvent() {
      this.overlay = true;
      await this.storeWorkspacesBatch();
      this.overlay = false;
      this.e6 = 1;
      this.$emit('closeDialogEvent');
    },
    async closeBatch() {
      await this.resetBatchState();
      this.e6 = 1;
      this.$emit('closeDialogEvent');
    },
    customFilter(item, queryText) {
      const textOne = item.domain_name.toLowerCase();
      const textTwo = item.domain_id.toString();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    }
  }
};
</script>
